module.exports = __webpack_public_path__ + "static/assets/1673822186b08d26b940fe615239a013.png";